"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSizedImage = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
exports.StyledSizedImage = styled_1.default.img `
  display: block;
  height: ${({ height }) => (height ? `${height}px` : 'auto')};
  width: 100%;
  object-fit: cover;

  // TODO: When integrating with BIOME, change this to 4px
  // from biome theme border-radius variable.
  border-radius: ${(0, ui_theme_1.fromTheme)('border_radius_medium')};
`;
//# sourceMappingURL=styles.js.map